import styled from 'styled-components'
import { grid, margin } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  width: 1,
  justifyContent: 'center',
  mt: [32, 96],
})`
  position: relative;
  color: ${themeGet('colors.white')};
`

export const ItemsWrapper = styled.div.attrs({
  gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
})`
  display: grid;
  grid-auto-rows: auto;
  width: 100%;
  gap: ${themeGet('space.3')}px;

  ${grid}
  ${margin}
`

export const Plate = styled.div`
  width: 100%;
  align-items: center;

  border-radius: 8px;
  border: solid 1px ${themeGet('colors.softPeach')};
`

export const StyledImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`
